/**
 * Display label for an air item type (category > type > typeName).
 */
export function getAirItemTypeLabel(airItemType) {
  if (!airItemType) return '-';
  const parts = [airItemType.category, airItemType.type, airItemType.typeName].filter(Boolean);
  return parts.join(' > ') || airItemType.typeName || '-';
}
